module.exports = __webpack_public_path__ + "media/images/athletes/130-40e80f6e45731c7201849d2f7938a499.png";